import { render } from "./AmountInput.vue?vue&type=template&id=36694e26&scoped=true"
import script from "./AmountInput.vue?vue&type=script&lang=js"
export * from "./AmountInput.vue?vue&type=script&lang=js"

import "./AmountInput.vue?vue&type=style&index=0&id=36694e26&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2653157369/src/mchanga-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36694e26"]])

export default __exports__